import { Document } from '@api/Trinium/Endpoints/Document';
import { CellProps } from '@components/DataGrid/types';

import styles from './DataGrid.DocumentControl.module.css';
import StackedTextCell from '@components/DataGrid/ColumnDefinitions/StackedTextCell.tsx';

type DocumentMobileItemProps = CellProps<Document>;

export default function DocumentMobileItem({ ...cellProps }: DocumentMobileItemProps) {
	const { row: document } = cellProps;
	return (
		<div className={styles['mobile-li']}>
			<div className={styles['document-info']}>
				<div className={styles['document-id']}>{document.id}</div>
				<span className={styles['document-type']}>{document.type}</span>
			</div>
			<div className={styles['flex-row']}>
				<div>
					<span className={styles['heading']}>Order</span>
					<span className={styles.ellipsis}>{document.jobId}</span>
				</div>
				<div>
					<span className={styles['heading']}>Container</span>
					<span className={styles.ellipsis}>{document.cntrId}</span>
				</div>
				<div>
					<span className={styles['heading']}>Chassis No.</span>
					<span className={styles.ellipsis}>{document.chassisId}</span>
				</div>
			</div>
			<div className={styles['flex-row']}>
				<div>
					<span className={styles['heading']}>Pickup</span>
					<span className={styles.ellipsis}>{document.puName}</span>
				</div>
				<div>
					<span className={styles['heading']}>Delivery</span>
					<span className={styles.ellipsis}>{document.delvName}</span>
				</div>
			</div>
			<div>
				<span className={styles['heading']}>Customer</span>
				<StackedTextCell
					primaryText={document.custName}
					secondaryText={document.csnCustRefNo}
				/>
			</div>
		</div>
	);
}
